import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  handleStepCurrent,
  fetchEducations,
} from "../../../features/profile/profileSlice";
import { Spin } from "antd";
import dayjs from "dayjs";

export default function EducationTab({ profileApplication, editProfile }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { educations = [], profileLoading } = useSelector(
    (state) => state.profile
  );

  useEffect(() => {
    dispatch(fetchEducations());
  }, [dispatch]);

  async function handleProfileBuilder() {
    await dispatch(handleStepCurrent(1));
    await navigate("/profile-builder");
  }

  return (
    <>
      <div className="flex justify-end">
        {profileApplication || editProfile ? null : (
          <button
            onClick={handleProfileBuilder}
            className="bg-transparent flex items-center border-none my-5"
          >
            <div className="bg-darkBlue rounded-full p-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4 16C4 15.4477 4.44772 15 5 15H27C27.5523 15 28 15.4477 28 16C28 16.5523 27.5523 17 27 17H5C4.44772 17 4 16.5523 4 16Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16 4C16.5523 4 17 4.44772 17 5V27C17 27.5523 16.5523 28 16 28C15.4477 28 15 27.5523 15 27V5C15 4.44772 15.4477 4 16 4Z"
                  fill="white"
                />
              </svg>
            </div>
            <span className="text-darkBlue font-medium text-[17px] ml-3">
              Add Education
            </span>
          </button>
        )}
      </div>

      {profileLoading && !educations.length && <Spin size="large" />}

      {educations.length > 0
        ? educations.map((item) => (
            <div key={item.id}>
              <div className="bg-white p-6 flex items-center justify-between w-full">
                <div className="w-full flex flex-col">
                  <h3 className="text-darkBlue text-[21px] font-bold">
                    {item.qualification}
                  </h3>
                  <p className="text-black333 font-medium text-[18px] my-1">
                    {item.institutionName}
                  </p>
                  <span className="text-black333 font-normal text-[19px]">
                    {dayjs(item.startDate).format("MMMM YYYY")} -{" "}
                    {dayjs(item.endDate).format("MMMM YYYY")}
                  </span>
                </div>
              </div>

              <div
                style={{
                  background: "#D8D8D88A",
                  height: "1px",
                  width: "100%",
                }}
                className="my-10"
              ></div>
            </div>
          ))
        : !profileLoading && (
            <div className="flex items-center justify-center w-full h-full py-10">
              <p className="text-gray-400">No education added yet</p>
            </div>
          )}
    </>
  );
}
